import ApiService from "./api.service";

const RefundService = {
	fetchRetailReturnSales(data) {
		return ApiService.post(`/sale/list-returnded`, data);
	},
	fetchWholeReturnSales(data) {
		return ApiService.post(`/sale/list-wh-returnded`, data);
	},
	getSaleList(data) {
		return ApiService.post(`/sale/search`, data);
	},
	getZochot(data) {
		return ApiService.post(`/zet-report/get-z-report/by-permission-dep-id`, data);
	},
	getOptomSaleList(data) {
		return ApiService.post(`/sale/optom-search`, data);
	},
	zReportsList(data) {
		return ApiService.post(`/zet-report/get-z-report-all`, data);
	},
	getZReportList(data) {
		return ApiService.post(`/zet-report/z-report-by-between-date`, data)
	},

	/**
	 * BU ESKI API ZREPORTNI ID SI ORQALI OLADIGAN (24.01.2020 DA YANGISI QO'SHILDI "ZET-REPORT.SERVICE.JS" GA)
	 * @param {*} zReport
	 * @param {*} depId
	 */
	zReportGetById(zReport, depId) {
		return ApiService.post(
			`/zet-report/get-z-report-by-id/${zReport}/${depId}`
		);
	},

	getItems(data) {
		return ApiService.get(`/sale/get/${data}`);
	},

	refoundSet(data) {
		return ApiService.post(`/sale/return-sale`, data);
	},

	getSaleByItemList(data) {
		return ApiService.post(`/sale/search-sale-item`, data)
	}
};

export default RefundService;
